import { cn } from '../../../utils/cn'

type ActiveBadgeProps = {
  active: boolean
}

export const ActiveBadge = ({ active }: ActiveBadgeProps) => (
  <span
    className={cn(
      'flex h-[19.8px] shrink-0 items-center rounded-full px-[9.72px] py-[2.52px] font-host text-[10.8px] font-semibold leading-[14.4px]',
      active
        ? 'border border-solid border-dash-svc-active-border bg-dash-svc-active-bg text-dash-svc-active'
        : 'border border-solid border-dash-svc-tab-border bg-dash-row-head-bg text-dash-muted',
    )}
  >
    {active ? 'Active' : 'Inactive'}
  </span>
)
